var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    attrs: {
      "id": "s-html5-qrcode-scanner"
    }
  }), _vm.cameraErrorMessage ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v(" " + _vm._s(_vm.cameraErrorMessage) + " "), _c('SharedButton', {
    staticClass: "s-btn-bg-primary mt-3",
    on: {
      "click": _vm.reloadPage
    }
  }, [_vm._v(" 重新整理頁面 ")]), _vm.showRetryButton ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mt-3",
    on: {
      "click": _vm.retryCamera
    }
  }, [_vm._v(" 重新授權相機 ")]) : _vm._e()], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }